import { CompanyUserAccountSettingsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class AccountSettings extends DomainEntity<CompanyUserAccountSettingsModelDto> {
    public static from(dto: CompanyUserAccountSettingsModelDto): AccountSettings {
        return new AccountSettings(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get useAccountNicknames() {
        return this.dto.useAccountNicknames;
    }

    public set useAccountNicknames(value: boolean) {
        this.dto.useAccountNicknames = value;
    }

    public get accountMaskTypeId() {
        return this.dto.accountMaskTypeId;
    }

    public set accountMaskTypeId(value: number) {
        this.dto.accountMaskTypeId = value;
    }

    public get allowUserToOverrideAccountMasking() {
        return this.dto.allowUserToOverrideAccountMasking;
    }

    public set allowUserToOverrideAccountMasking(value: boolean) {
        this.dto.allowUserToOverrideAccountMasking = value;
    }
}
